import axios from 'axios';

const API_BASE_URL = 'https://api.edificiosolyluna.uy/api'; // <--- ¡IMPORTANTE! Cambia esto al puerto real de tu API de ASP.NET Core

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para añadir el token JWT a las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      const data = error.response.data;

      if (data.error === "MustChangePassword") {
        // Redirigir al usuario a la página de cambio de contraseña
        window.location.href = "/change-password";
      }
    }
    return Promise.reject(error);
  }
);

export default api;